<template>
  <v-container
      fluid
  >
    <v-row>
      <v-col cols="12" sm="12" md="12" class="px-0">
        <v-card class="pa-5" tile>
          <v-data-table
            class="clickable"
            :headers="headers"
            :loading="loading"
            :items="items"
            :options.sync="options"
            :items-per-page-items="itemsPerPageItems"
            :server-items-length="totalItems"
            @click:row="showDialog"
          >
            <template v-slot:top>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-folder-search"
                    label="Zoeken"
                    single-line
                    hide-details
                    clearable
                    class="ml-3"
                  ></v-text-field>
                </v-col>
              </v-row>
            </template>

            <template v-slot:no-results>
              <span>{{ $t('No matching data found') }}</span>
            </template>

            <template v-slot:no-data>
              <span>{{ $t('No data available') }}</span>
            </template>
          </v-data-table>

          <ItemDialog ref="itemDialog" @update="fetchItems" />

        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ApiService from '@/services/api.service'
import SessionService from '@/services/session.service'
import ItemDialog from '@/components/TranslationDialog'
import _ from 'lodash'


export default {
  props: ['type'],
  components: {
    ItemDialog,
  },
  data: () => ({
    items: [],
    totalItems: 10,
    loading: true,
    options: {
        itemsPerPage: 10,
    },
    search: '',

    itemsPerPageItems: [5, 10, 25, 50],

  }),
  computed: {
    headers() {
      return [
        { text: this.$t('Category'), value: 'category', align: 'left', sortable: true, width: '22%' },
        { text: this.$t('Message'), value: 'message', align: 'left', sortable: true, width: '22%' },
        { text: this.$t('English'), value: 'translations[en]', align: 'left', sortable: false, width: '22%' },
        { text: this.$t('Spanish'), value: 'translations[es]', align: 'left', sortable: false, width: '22%' },
      ]
    },
  },
  watch: {
    options: {
      handler () {
        this.fetchItems()
      },
      deep: true
    },
    '$i18n.locale': function () {
      this.fetchItems()
      
    },
    search() {
      this.fetchItems()
    },
  },
  created() {   
    this.$store.dispatch('session/title', this.$t('Translation'))
    this.restoreFilters()
  },
  methods: {
    showDialog(item = null) {
      this.$refs.itemDialog.showDialog(item ? item.id : null)
    },
    fetchItems: _.debounce(function() {
      this.loading = true
      this.saveFilters()
      ApiService.index('/translation', this.options, {
        params: {
          filter: {
            query: this.search,
          },
        },
      }).then(({ items, total })  => {
        this.items = items
        this.totalItems = total
        this.loading = false
      }).catch(() => {
        this.loading = 'error'
      })
    }, 250),
    saveFilters() {
      SessionService.setItem('filter_translation', {
        search: this.search,
        options: this.options,
      })
    },
    restoreFilters() {
      let filters = SessionService.getItem('filter_translation')
      if (filters) {
        this.search = filters.search
        this.options = filters.options
      }
    },
  },
}
</script>

<style scoped>

</style>

